<div class="pm-choice-overlay">
  <!-- Real button, not a div with a click handler: dismissal works from the keyboard and needs no
       NOSONAR suppression. It sits behind the panel and carries none of the dimming itself. -->
  <button type="button" class="pm-choice-overlay__backdrop" aria-label="Close dialog"
    (click)="closed.emit()"></button>

  <div class="pm-choice-modal" role="dialog" aria-modal="true" [attr.aria-labelledby]="titleId">
    <header class="pm-choice-modal__head">
      <div class="pm-choice-modal__head-main">
        <span class="pm-choice-modal__head-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
            stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="10" cy="7.5" r="3.5"></circle>
            <path d="M3.5 20.5c0-3.6 2.9-6.5 6.5-6.5"></path>
            <path d="M17.5 14v6.5M20.75 17.25h-6.5"></path>
          </svg>
        </span>
        <span class="pm-choice-modal__head-text">
          <span class="pm-choice-modal__title" [id]="titleId">{{ title }}</span>
          <span class="pm-choice-modal__subtitle">{{ subtitle }}</span>
        </span>
      </div>

      <button type="button" class="pm-choice-modal__close" aria-label="Close" (click)="closed.emit()">
        <svg viewBox="0 0 20 20" width="20" height="20" fill="none" stroke="currentColor"
          stroke-width="1.5" stroke-linecap="round" aria-hidden="true">
          <path d="M5 5l10 10M15 5L5 15"></path>
        </svg>
      </button>
    </header>

    <div class="pm-choice-modal__options">
      @for (opt of options; track opt.id) {
      <button type="button" class="pm-choice-card" (click)="choose.emit(opt.id)">
        <span class="pm-choice-card__icon" aria-hidden="true">
          @switch (opt.icon) {
          @case ('building') {
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
            stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 21V4.5A1.5 1.5 0 0 1 4.5 3h6A1.5 1.5 0 0 1 12 4.5V21"></path>
            <path d="M12 21V9.5h6.5A1.5 1.5 0 0 1 20 11v10"></path>
            <path d="M6 7.5h3"></path>
            <path d="M8 21v-4h3v4"></path>
          </svg>
          }
          @case ('pencil') {
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
            stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
            <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L9 17l-4 1 1-4z"></path>
            <path d="M3 21h18"></path>
          </svg>
          }
          @case ('upload') {
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
            stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 16V4"></path>
            <path d="M8 7.5L12 3.5l4 4"></path>
            <path d="M4 15v3.5A1.5 1.5 0 0 0 5.5 20h13a1.5 1.5 0 0 0 1.5-1.5V15"></path>
          </svg>
          }
          @default {
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
            stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="8" r="3.5"></circle>
            <path d="M5 20c0-3.6 3.1-6.5 7-6.5s7 2.9 7 6.5"></path>
          </svg>
          }
          }
        </span>
        <span class="pm-choice-card__text">
          <span class="pm-choice-card__title">{{ opt.title }}</span>
          <span class="pm-choice-card__desc">{{ opt.description }}</span>
        </span>
      </button>
      }
    </div>
  </div>
</div>
